exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-d6e9040c]{font-family:Arial}.title[data-v-d6e9040c]{color:#42c562}button[data-v-d6e9040c]{margin-top:20px}video[data-v-d6e9040c]{background-color:#ddd}#app[data-v-d6e9040c]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6e9040c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 9
// module chunks = 0